import React from 'react';
import { motion } from 'framer-motion';
import Logo from './Logo';

const AboutSection = () => {
  return (
    <section id="about" className="relative py-24 sm:py-32 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div className="absolute right-0 top-0 w-[400px] h-[400px] bg-amber-50/50 rounded-full blur-[100px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <span className="text-amber-500 font-semibold text-sm uppercase tracking-wider mb-4 block">About Us</span>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight tracking-tight">
              What is White<br />Shiba Inu?
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed">
              White Shiba Inu is a community-driven meme token inspired by the legendary Shiba Inu, but reimagined for a new era. We represent purity, transparency, and the collective power of a united community. No presales. No team tokens. Just a fair launch and a mission to build the strongest meme coin community in crypto.
            </p>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="relative flex justify-center"
          >
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-amber-200 to-orange-200 rounded-full blur-[60px] opacity-50" />
              
              {/* Card */}
              <motion.div
                whileHover={{ scale: 1.02, rotate: 2 }}
                className="relative bg-white rounded-3xl p-10 shadow-xl border border-gray-100"
              >
                <Logo className="w-48 h-48 mx-auto mb-6" />
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">$WhiteShiba</h3>
                  <p className="text-amber-500 font-medium">Pure & Powerful</p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
